import { CSSProperties, useTheme } from 'styled-components';
import { LineSegment } from 'victory';

interface CustomGridComponentProps {
  index: number;
  ticks: number[];
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  style: CSSProperties;
  datum: number;
  id: string;
}

interface CustomGridProps {
  isLegacy: boolean;
}

export const CustomGrid: React.FC<CustomGridProps> = ({ isLegacy, ...props }) => {
  const theme = useTheme();

  const gridProps = props as CustomGridComponentProps;
  const isLastLine = gridProps.index === 0;
  const newStyleStoke = { stroke: theme.secondary.skyBlue, strokeWidth: 1 };

  return <LineSegment {...props} style={isLastLine && !isLegacy ? newStyleStoke : gridProps.style} />;
};
